export const requireOrganisation = (urlPath: string): boolean => {
    switch (true) {
        case urlPath.includes('/admin/') &&
            !urlPath.includes('/admin/organisation/') &&
            !urlPath.includes('/admin/study/') &&
            !urlPath.includes('/admin/audit-log'):
        case urlPath.includes('/user/profile'):
            return false;
        default:
            return true;
    }
};

export const requireStudy = (urlPath: string): boolean => {
    switch (true) {
        case urlPath.includes('/home'):
        case urlPath.includes('/admin/') && !urlPath.includes('/admin/study/'):
        case urlPath.includes('/organisation/'):
        case urlPath.includes('/user/profile'):
            return false;
        default:
            return true;
    }
};

export const requireDataset = (urlPath: string): boolean => {
    switch (true) {
        case urlPath.includes('/home'):
        case urlPath.includes('/risk-assessment'):
        case urlPath.includes('/central-monitoring/dataset-hub'):
        case urlPath.includes('/central-monitoring/study-team'):
        case urlPath.includes('/central-monitoring/reports'):
        case urlPath.includes('/central-monitoring/manage-signatories'):
        case urlPath.includes('/central-monitoring/generation-history'):
        case urlPath.includes('/legacy-central-monitoring/manage-actions'):
        case urlPath.includes('/legacy-central-monitoring/manage-observations'):
        case urlPath.includes('/legacy-central-monitoring/team'):
        case urlPath.includes('/legacy-central-monitoring/reports'):
        case urlPath.includes('/legacy-central-monitoring/generation-history'):
        case urlPath.includes('/legacy-central-monitoring/manage-signatories'):
        case urlPath.includes('/legacy-central-monitoring/legacy-reports'):
        case urlPath.includes('/legacy-central-monitoring/review-report'):
        case urlPath.includes('/admin/'):
        case urlPath.includes('/organisation/'):
        case urlPath.includes('/study/'):
        case urlPath.includes('/user/profile'):
        case urlPath.includes('/data-quality'):
        case urlPath.includes('/subject-monitoring/study-team'):
        case urlPath.includes('/subject-monitoring/manage-review-plans'):
            return false;
        default:
            return true;
    }
};

export const isSMPage = (path: string) => {
    return path.startsWith('/subject-monitoring');
};

export const isCM2Page = (path: string) => {
    return path.startsWith('/central-monitoring') || isSMPage(path);
};

export const isLegacyCMPage = (path: string) => {
    return path.startsWith('/legacy-central-monitoring');
};
